<template>
  <button
    type="button"
    class="f360-feedback-button"
    :class="{ 'f360-feedback-button--active': isActive }"
    @click="emit('select', value)"
  >
    <MaterialIcon :icon="icon" size="14px" />
    {{ label }}
  </button>
</template>

<script setup lang="ts">
type TProps = {
  label: string;
  icon: string;
  value: TFeedbackValue;
  isActive: boolean;
}
import MaterialIcon from '@/ui/components/Icons/MaterialIcon/MaterialIcon.vue'
type TFeedbackValue = "true" | "false";
defineProps<TProps>();
const emit = defineEmits<{
  (e: "select", value: TFeedbackValue): void;
}>();
</script>

<style scoped lang="scss">
.f360-feedback-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 52px;
  justify-content: center;
  padding: 4px 10px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  color: #5d5d5d;
  background: transparent;
  font-size: 11px;
  line-height: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;

  &--active {
    color: #0055ff;
    border-color: #0055ff;
  }
}
</style>
